// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.btn, .form-buttons .btn,
.form-buttons .btn:disabled {
  background: #003da5;
  color: #fff;
  padding: 10px 24px;
  white-space: nowrap;
  width: auto;
  height: auto;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
}
.btn.btn-primary {
  background-color: #003da5;
  border-color: #003da5;
}
.btn.btn-primary:hover, .btn.btn-primary:active {
  background-color: #002c7a;
}
.btn.btn-secondary {
  background-color: #fff;
  border-color: #003da5;
  color: #003da5;
}
.btn.btn-secondary:hover, .btn.btn-secondary:active {
  background-color: #dcefff;
  border-color: #003da5;
  color: #003da5;
}
.btn.btn-disabled,
.btn.btn disabled,
.form-buttons .btn:disabled disabled {
  background-color: #acacac;
  color: #fff;
}
.btn.btn-disabled:hover, .btn.btn-disabled:active,
.btn.btn disabled:hover,
.btn.btn disabled:active {
  background-color: #acacac;
  color: #fff;
}
.btn.btn.border-primary {
  border-color: #003da5 !important;
}
.btn.dropdown-toggle {
  padding: 10px 18px;
}
.btn.dropdown-toggle:after {
  margin-left: 10px;
}
.btn:disabled {
  font-size: 12px;
  width: auto;
  height: auto;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0 0;
  gap: 24px;
}
.p-fileupload .p-fileupload-row .upload-row {
  padding: 0;
  margin-top: 60px;
  text-align: left;
}

.nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}

.sidebar {
  background: #ffffff;
  text-align: center;
  display: block;
  position: relative;
}
.sidebar .active {
  background: rgba(1, 104, 191, 0.05);
  border-radius: 0px;
  position: relative;
  color: #003da5;
  font-weight: 700;
}
.sidebar .active img {
  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);
}
.sidebar .subactive {
  background: rgba(1, 104, 191, 0.07);
}
.sidebar .parent-link {
  display: flex;
  justify-content: space-evenly;
  margin-left: 5px !important;
  flex-direction: column;
  align-items: center;
  margin-left: -15px;
}
.sidebar .parent-link.active::after {
  content: "";
  width: 15px;
  height: 22px;
  border-radius: 100% 0 0 100%/50% 0 0 50%;
  position: absolute;
  right: 0;
  z-index: 10;
}
.sidebar .logoutColor {
  color: red;
}

.pg-logo {
  width: 38px;
  height: 36px;
}

.nav-item {
  width: 105%;
}
.nav-item ul {
  margin: 0;
}
.nav-item:nth-child(3) {
  margin-top: 20px;
}
.nav-item a {
  color: #acacac;
  position: relative;
  align-items: center;
  justify-content: center;
}
.nav-item:nth-child(6) a {
  color: #ff0000;
}

.sub-active {
  background: rgba(1, 104, 191, 0.07) !important;
  color: #003da5;
}

.nav-link {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  color: green;
}
.nav-link span {
  position: relative;
  width: 100%;
  padding: 0 15px;
}

.toggle-logo {
  width: 45px;
  height: auto;
}

.toggle-collapsed,
.toggle-expanded {
  position: absolute;
  top: 14px;
  cursor: pointer;
  z-index: 1000;
  width: 24px;
  height: 24px;
  transition: right 0.3s ease-in-out;
  transition-delay: 0.2s;
  background: #ffffff;
}

.toggle-collapsed {
  right: -12px;
}

.toggle-expanded {
  right: -12px !important;
}

.nav {
  padding-top: 0px;
}

.add-project {
  border-top: 0.5px solid #acacac;
  text-align: center;
  width: 100%;
  margin: 20px auto 0;
}
.add-project .nav-item {
  padding: 30px 0 0;
  font-size: 14px;
}
.add-project .button-layout {
  margin-left: 20px;
  background: #003da5;
  border-radius: 20px;
  padding: 16px 5px;
}
.add-project .button-layout img {
  margin: 0 -10px 0 0;
}

.titleCollapse {
  font-size: 11px;
  padding: 10px 2px 15px;
  font-weight: 500;
  color: #595959;
  line-height: 1.5;
}

.titleExpand {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #595959;
  line-height: 1.5;
}

.logo {
  padding-top: 20px;
}

.add-project img {
  width: 21px;
  height: 25px;
  cursor: pointer;
}

.isToggle {
  margin: auto;
  padding: 40px;
}

.addProjectExpand {
  border-top: 0.5px solid #acacac;
  text-align: center;
  width: 100%;
  margin: 5px auto 0;
  padding-top: 10px;
}
.addProjectExpand img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.tooltip {
  color: #fff;
  background-color: transparent;
  border-color: #007bff;
  margin-top: 0%;
  z-index: 10000000 !important;
}

.tooltip-inner {
  background-color: #e1edf8 !important;
}

.toolname {
  color: #003da5;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  background: transparent;
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  border-right-color: #e1edf8 !important;
}

.create {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  font-family: "Montserrat";
  font-style: normal;
  padding-top: 5px;
  margin-left: -1px;
}

.left-nav-wrapper {
  flex-direction: column;
  display: flex;
  width: 100%;
}
.left-nav-wrapper a {
  text-decoration: none;
  padding: 7px 0px;
  color: #acacac;
  cursor: pointer !important;
}
.left-nav-wrapper a:hover {
  color: #003da5;
  font-weight: bold;
  background: #e1edf8;
}
.left-nav-wrapper a .active {
  background: rgba(1, 104, 191, 0.05);
  border-radius: 0px;
  position: relative;
  font-weight: 700;
}
.left-nav-wrapper a:nth-last-of-type(2) {
  border-top: 1px solid grey;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/components/SideBar/index.scss"],"names":[],"mappings":"AACA;EACE,yBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACAF;ADOA;;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;ACJF;ADMI;EACE,yBAAA;EACA,qBAAA;ACJN;ADKM;EAEE,yBAAA;ACJR;ADOI;EACE,sBAAA;EACA,qBAAA;EACA,cAAA;ACLN;ADMM;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;ACLR;ADQI;;;EAEE,yBAAA;EACA,WAAA;ACLN;ADMM;;;EAEE,yBAAA;EACA,WAAA;ACHR;ADMI;EACE,gCAAA;ACJN;ADOE;EACE,kBAAA;ACLJ;ADMI;EACE,iBAAA;ACJN;ADOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ACLJ;;ADQA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;ACLF;ADaI;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;ACXN;;ADgBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;ACbF;;AAjFA;EACE,mBDMY;ECLZ,kBAAA;EACA,cAAA;EACA,kBAAA;AAoFF;AAlFE;EACE,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAoFJ;AAlFI;EACE,iGAAA;AAoFN;AAhFE;EACE,mCAAA;AAkFJ;AA/EE;EACE,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAiFJ;AA7EI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EAEA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AA8EN;AA1EE;EACE,UAAA;AA4EJ;;AAxEA;EACE,WAAA;EACA,YAAA;AA2EF;;AAxEA;EACE,WAAA;AA2EF;AAzEE;EACE,SAAA;AA2EJ;AAxEE;EACE,gBAAA;AA0EJ;AAvEE;EAEE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAwEJ;AApEI;EACE,cAAA;AAsEN;;AAjEA;EACE,8CAAA;EACA,cAAA;AAoEF;;AAjEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAoEF;AA7DE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA+DJ;;AA3DA;EACE,WAAA;EACA,YAAA;AA8DF;;AA3DA;;EAEE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,sBAAA;EACA,mBAAA;AA8DF;;AA3DA;EACE,YAAA;AA8DF;;AA3DA;EACE,uBAAA;AA8DF;;AA3DA;EACE,gBAAA;AA8DF;;AA3DA;EACE,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AA8DF;AAzDE;EACE,iBAAA;EACA,eAAA;AA2DJ;AAxDE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AA0DJ;AAxDI;EACE,mBAAA;AA0DN;;AArDA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAwDF;;AArDA;EACE,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AAuDF;;AApDA;EACE,iBAAA;AAuDF;;AAnDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAsDJ;;AAlDA;EACE,YAAA;EACA,aAAA;AAqDF;;AAlDA;EACE,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAqDF;AA5CE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA8CJ;;AAxCA;EACE,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EAEA,4BAAA;AA0CF;;AAvCA;EACE,oCAAA;AA0CF;;AAvCA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AA0CF;;AAvCA;;EAEE,sCAAA;AA0CF;;AAvCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,iBAAA;AAyCF;;AAtCA;EACE,sBAAA;EACA,aAAA;EACA,WAAA;AAyCF;AAvCE;EACE,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAyCJ;AAvCI;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;AAyCN;AAtCI;EACE,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAwCN;AArCI;EACE,0BAAA;AAuCN","sourcesContent":["// Import font file\n@font-face {\n  font-family: 'Montserrat';\n  src: url('./../assets/fonts/Montserrat-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n$primary-color: #003da5;\n$white-color: #ffffff;\n$gray-color: '#ACACAC';\n\n.btn {\n  background: #003da5;\n  color: #fff;\n  padding: 10px 24px;\n  white-space: nowrap;\n  width: auto;\n  height: auto;\n  font-size: 12px;\n  line-height: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 20px;\n  &.btn {\n    &-primary {\n      background-color: #003da5;\n      border-color: #003da5;\n      &:hover,\n      &:active {\n        background-color: #002c7a;\n      }\n    }\n    &-secondary {\n      background-color: #fff;\n      border-color: #003da5;\n      color: #003da5;\n      &:hover,\n      &:active {\n        background-color: #dcefff;\n        border-color: #003da5;\n        color: #003da5;\n      }\n    }\n    &-disabled,\n    disabled {\n      background-color: #acacac;\n      color: #fff;\n      &:hover,\n      &:active {\n        background-color: #acacac;\n        color: #fff;\n      }\n    }\n    &.border-primary {\n      border-color: #003da5 !important;\n    }\n  }\n  &.dropdown-toggle {\n    padding: 10px 18px;\n    &:after {\n      margin-left: 10px;\n    }\n  }\n  &:disabled {\n    font-size: 12px;\n    width: auto;\n    height: auto;\n  }\n}\n.form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 10px 0 0;\n  gap: 24px;\n  .btn,\n  .btn:disabled {\n    @extend .btn;\n  }\n}\n.p-fileupload {\n  .p-fileupload-row {\n    .upload-row {\n      padding: 0;\n      margin-top: 60px;\n      text-align: left;\n    }\n  }\n}\n\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n","@import '../../scss/style.scss';\n\n.sidebar {\n  background: $white-color;\n  text-align: center;\n  display: block;\n  position: relative;\n\n  .active {\n    background: rgba(1, 104, 191, 0.05);\n    border-radius: 0px;\n    position: relative;\n    color: #003da5;\n    font-weight: 700;\n\n    img {\n      filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);\n    }\n  }\n\n  .subactive {\n    background: rgba(1, 104, 191, 0.07);\n  }\n\n  .parent-link {\n    display: flex;\n    justify-content: space-evenly;\n    margin-left: 5px !important;\n    flex-direction: column;\n    align-items: center; // center align icon and text horizontally\n    margin-left: -15px;\n  }\n\n  .parent-link.active {\n    &::after {\n      content: '';\n      width: 15px;\n      height: 22px;\n      //background-color: #0168bf;\n      border-radius: 100% 0 0 100% / 50% 0 0 50%;\n      position: absolute;\n      right: 0;\n      z-index: 10;\n    }\n  }\n\n  .logoutColor {\n    color: red;\n  }\n}\n\n.pg-logo {\n  width: 38px;\n  height: 36px;\n}\n\n.nav-item {\n  width: 105%;\n\n  ul {\n    margin: 0;\n  }\n\n  &:nth-child(3) {\n    margin-top: 20px;\n  }\n\n  a {\n    // padding: 10px 2px 0px;\n    color: #acacac;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &:nth-child(6) {\n    a {\n      color: #ff0000;\n    }\n  }\n}\n\n.sub-active {\n  background: rgba(1, 104, 191, 0.07) !important;\n  color: #003da5;\n}\n\n.nav-link {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  text-align: center;\n  color: green;\n\n  // display: flex;\n  // img {\n  //   width: 40px;\n  //   height: 40px;\n  // }\n  span {\n    position: relative;\n    width: 100%;\n    padding: 0 15px;\n  }\n}\n\n.toggle-logo {\n  width: 45px;\n  height: auto;\n}\n\n.toggle-collapsed,\n.toggle-expanded {\n  position: absolute;\n  top: 14px;\n  cursor: pointer;\n  z-index: 1000;\n  width: 24px;\n  height: 24px;\n  transition: right 0.3s ease-in-out;\n  transition-delay: 0.2s;\n  background: #ffffff;\n}\n\n.toggle-collapsed {\n  right: -12px;\n}\n\n.toggle-expanded {\n  right: -12px !important;\n}\n\n.nav {\n  padding-top: 0px;\n}\n\n.add-project {\n  border-top: 0.5px solid #acacac;\n  text-align: center;\n  width: 100%;\n  margin: 20px auto 0;\n\n  //   .collapse-img {\n  //     padding-left: 15px;\n  //   }\n  .nav-item {\n    padding: 30px 0 0;\n    font-size: 14px;\n  }\n\n  .button-layout {\n    margin-left: 20px;\n    background: #003da5;\n    border-radius: 20px;\n    padding: 16px 5px;\n\n    img {\n      margin: 0 -10px 0 0;\n    }\n  }\n}\n\n.titleCollapse {\n  font-size: 11px;\n  padding: 10px 2px 15px;\n  font-weight: 500;\n  color: #595959;\n  line-height: 1.5;\n}\n\n.titleExpand {\n  margin-top: 4px;\n  font-size: 13px;\n  // padding: 10px 10px -1px;\n  font-weight: 500;\n  color: #595959;\n  line-height: 1.5;\n}\n\n.logo {\n  padding-top: 20px;\n}\n\n.add-project {\n  img {\n    width: 21px;\n    height: 25px;\n    cursor: pointer;\n  }\n}\n\n.isToggle {\n  margin: auto;\n  padding: 40px;\n}\n\n.addProjectExpand {\n  border-top: 0.5px solid #acacac;\n  text-align: center;\n  width: 100%;\n  margin: 5px auto 0;\n  padding-top: 10px;\n\n  //   .collapse-img {\n  //     padding-left: 15px;\n  //   }\n  // .nav-item {\n  //   padding: 18px 0 0;\n  //   font-size: 14px;\n  // }\n  img {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n  }\n}\n\n//=============================================//tooltip\n\n.tooltip {\n  color: #fff;\n  background-color: transparent;\n  border-color: #007bff;\n  margin-top: 0%;\n  // margin-left: -1.5%;\n  z-index: 10000000 !important;\n}\n\n.tooltip-inner {\n  background-color: #e1edf8 !important;\n}\n\n.toolname {\n  color: #003da5;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  background: transparent;\n}\n\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before {\n  border-right-color: #e1edf8 !important;\n}\n\n.create {\n  color: #595959;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: 'Montserrat';\n  font-style: normal;\n\n  padding-top: 5px;\n  margin-left: -1px;\n}\n\n.left-nav-wrapper {\n  flex-direction: column;\n  display: flex;\n  width: 100%;\n\n  a {\n    text-decoration: none;\n    padding: 7px 0px;\n    color: #acacac;\n    cursor: pointer !important;\n\n    &:hover {\n      color: #003da5;\n      font-weight: bold;\n      background: #e1edf8;\n    }\n\n    .active {\n      background: rgba(1, 104, 191, 0.05);\n      border-radius: 0px;\n      position: relative;\n      font-weight: 700;\n    }\n\n    &:nth-last-of-type(2) {\n      border-top: 1px solid grey;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
